<template>
  <a
    class="become-partner-navbar"
  >
    <c-button
      size="lg"
      icon="certificate"
      id="button-become-partner"
    >
      Seja parceiro
    </c-button>
  </a>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.become-partner-navbar {
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Navbar/BecomePartnerNavbar.vue